/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import isNil from 'lodash.isnil';
import {translate} from '@ion/core/src/locale/locale';
import {
  getCodeMappings,
  getErrorCode,
  hasDiagCode
} from '@ion/core/src/services/JobMetaDefinitions';
import Tooltip from '@ion/dls/src/components/tooltip/Tooltip';
import {GridResult} from '@ion/dls/src/grid/PaginationControls';
import {DLSTheme} from '@ion/dls/src/types/types';

// defines the styles used by the attributes and values cells ...
export const useStyles = makeStyles((theme: DLSTheme) => ({
  cellValue : {
    position     : 'relative',
    lineHeight   : '20px',
    textOverflow : 'ellipsis',
    wordBreak    : 'break-word',
    overflow     : 'hidden'
  }
}));

const APP_ID = 'App Id';

/**
 * Grid renderer component to Display Mapped values of StatCode
 * and DiagCode.
 */
export const FileHistoryOTAStatusCode = ({data}: GridResult) => {
  const {
    data: {
      otaStatus,
      otaDiagCode,
      otaDiagMessage,
      newDeviceFile : {
        platforms = []
      } = {}
    } = {}
  } = data || {};

  const {
    statCode,
    diagCode,
    diagCode32Bit
  } = getCodeMappings();

  const hasErrorMessage = () => {
    return !isNil(otaStatus) && !isNil(otaDiagCode);
  };

  const getErrorMessage = () => {
    return hasErrorMessage() ? translate('downloadjobs:failureReason', {
      statcode : otaStatus,
      diagCode : parseInt(otaDiagCode),
      diagMsg  : otaDiagMessage
    }) : '';
  };

  const getAppId = () => {
    const platformArray = platforms?.find(item => item?.description?.indexOf(APP_ID) !== -1);
    return platformArray?.value;
  };

  const classes = useStyles();
  const error   = getErrorMessage();
  const appId   = getAppId();

  return hasDiagCode(error) ? (
    <Tooltip arrow
      placement={'bottom'}
      title={<span>{getErrorCode({error, appId, statCode, diagCode, diagCode32Bit})}</span>}>
      <div className={classes.cellValue}>
        {getErrorCode({error, appId, statCode, diagCode, diagCode32Bit})}
      </div>
    </Tooltip>
  ) : <span>{error}</span>;
};

export default FileHistoryOTAStatusCode;
